import { render, staticRenderFns } from "./WarehousePurchaseOrderDialog.vue?vue&type=template&id=2b261257"
import script from "./WarehousePurchaseOrderDialog.vue?vue&type=script&lang=js"
export * from "./WarehousePurchaseOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports